import React, { useEffect, useState } from 'react';
import { Box, Typography, Grid, Card, CardMedia, CardContent, Button, makeStyles } from '@material-ui/core';
import GoogleSheetsService from '../../services/GoogleSheetsService';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        // padding: theme.spacing(3),
        // backgroundColor: '#f4f6f8', // Màu nền trang
    },
    title: {
        // textAlign: 'center',
        marginBottom: theme.spacing(3),
        fontWeight: 'bold',
        fontSize: '1.8rem',
        color: '#0277bd',
        textDecoration: 'underline'
    },
    card: {
        [theme.breakpoints.up('md')]: {
            maxWidth: 345,
        },
        with: '100%',
        height: 370,
        margin: '10px',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(122, 94, 94, 0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        display: 'flex',
        flexDirection: 'column',
        '&:hover $mediaChild': { // Áp dụng style cho mediaChild khi hover vào parentContainer
            transform: 'scale(1.1)'
        }
    },
    media: {
        height: 200,
    },
    mediaChild: {
        height: 150,
        margin: theme.spacing(7), // Margin mặc định cho màn hình nhỏ hơn
        transition: 'transform 0.3s ease-in-out',
        [theme.breakpoints.up('md')]: {
            margin: theme.spacing(2), // Margin cho màn hình medium trở lên
        },
    },
    cardContent: {
        flexGrow: 1,
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
    },
    carName: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
        fontSize: '1rem',
        color: '#212121',
        '&:hover': {
            color: '#1976d2',
        },
    },
    price: {
        color: '#d32f2f',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        marginBottom: theme.spacing(1),
    },
    button: {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#1565c0',
        },
    },
    gridDanhSach: {
        marginBottom: '15px'
    },
    priceButton: {
        marginTop: 'auto',
    },
    button61: {
        borderColor: '#1976d2',
        color: '#1976d2',
        '&:hover': {
            backgroundColor: '#1565c0',
            color: '#fff',
        },
        [theme.breakpoints.up('md')]: {
            // marginLeft: theme.spacing(2),
            marginTop: theme.spacing(1),
        },
    },
    link: {
        textDecoration: 'none !important',
        color: 'inherit !important', // Kế thừa màu từ button
        '&:hover': {
            textDecoration: 'none !important',
            color: 'inherit !important',
        },
        '&:focus': {
            outline: 'none !important',
        },
    }
}));

const DanhSach = () => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { product } = useParams();
    const [name, setName] = useState([]);

    useEffect(() => {
        const fetchData = async (sheetName) => {
            try {
                const data = await GoogleSheetsService.getData(sheetName, 'A:H');
                setData(data);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        const fetchName = (sheetName) => {
            switch (sheetName) {
                case 'territory':
                    setName('FORD TERRITORY');
                    break;
                case 'everest':
                    setName('FORD EVEREST');
                    break;
                case 'ranger':
                    setName('FORD RANGER');
                    break;
                case 'transit':
                    setName('FORD TRANSIT');
                    break;
                case 'explorer':
                    setName('EXPLORER');
                    break;
                default:
                    setName('KHÔNG GIÁ TRỊ');;
            }
        }
        fetchName(product);
        fetchData(product);
    }, [product]);

    return (
        <Box className={classes.root}>
            <Box>
                <Typography variant="h5" className={classes.title}>
                    {name}
                </Typography>
                <Grid container>
                    {data.map((xe, index) => (
                        <Grid item key={index} xs={12} sm={6} md={4} className={classes.gridDanhSach}>
                            <Card className={classes.card}>
                                <Box className={classes.media}>
                                    <Link to={product === 'explorer' ? '/suv/ford-explorer' : product === 'transit' ? '/trucks/transit/compare' : `/chi-tiet/${product}/${xe.tenLink}`} className={classes.link}>
                                        <CardMedia
                                            className={classes.mediaChild}
                                            image={xe.anhdanhsach}
                                            title={xe.ten}
                                        />
                                    </Link>
                                </Box>
                                <CardContent className={classes.cardContent}>
                                    <Typography variant="subtitle1" className={classes.carName}>
                                        <Link to={product === 'explorer' ? '/suv/ford-explorer' : product === 'transit' ? '/trucks/transit/compare' : `/chi-tiet/${product}/${xe.tenLink}`} className={classes.link}>
                                            {xe.tendaydu}
                                        </Link>
                                    </Typography>
                                    <Box className={classes.priceButton}>
                                        <Typography variant="subtitle2" className={classes.price}>
                                            {xe.gia} VNĐ
                                        </Typography>
                                        <Button variant="contained" href={`/dang-ky-lai-thu/${xe.tenLink}`} className={classes.button} fullWidth>
                                            Đăng ký lái thử
                                        </Button>
                                        <Button variant="outlined" href={`/bao-gia/${xe.tenLink}`} className={classes.button61} fullWidth>
                                            Báo giá
                                        </Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default DanhSach;
